// context/ModalContext.jsx
import React, { createContext, useState, useContext } from 'react';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
    const [modalState, setModalState] = useState({
        isOpen: false,
        type: 'info',
        title: '',
        message: '',
        onConfirm: null,
        confirmText: 'Подтвердить',
        cancelText: 'Отмена'
    });

    const showModal = ({ 
        type = 'info', 
        title, 
        message, 
        onConfirm, 
        confirmText = 'Подтвердить',
        cancelText = 'Отмена'
    }) => {
        setModalState({
            isOpen: true,
            type,
            title,
            message,
            onConfirm,
            confirmText,
            cancelText
        });
    };

    const showConfirm = (title, message, onConfirm) => {
        setModalState({
            isOpen: true,
            type: 'confirm',
            title,
            message,
            onConfirm,
            confirmText: 'Подтвердить',
            cancelText: 'Отмена'
        });
    };

    const showAlert = (title, message, type = 'info') => {
        setModalState({
            isOpen: true,
            type,
            title,
            message,
            onConfirm: null,
            confirmText: 'OK',
            cancelText: null
        });
    };

    const hideModal = () => {
        setModalState(prev => ({ ...prev, isOpen: false }));
    };

    const handleConfirm = () => {
        if (modalState.onConfirm) {
            modalState.onConfirm();
        }
        hideModal();
    };

    const value = {
        showModal,
        showConfirm,
        showAlert,
        hideModal,
        modalState,
        handleConfirm
    };

    return (
        <ModalContext.Provider value={value}>
            {children}
        </ModalContext.Provider>
    );
};